module.exports = __webpack_public_path__ + "img/save_icon.0f24a30b.webp";